import { ViewOpts } from '@play-co/timestep-core/ui';
import TeamTab from './TeamTab';
import sounds from 'src/lib/sounds';
import { FlexBoxView } from '@play-co/timestep-core/flexbox';

interface TeamTabConfig {
  label: string;
  onClick: () => Promise<void> | void;
  tracking: { feature: string; $subFeature: string };
}

export interface TeamNavConfig {
  tabs: TeamTabConfig[];

  tabOpts?: ViewOpts;
  selectedIndex?: number;
}

export default class TeamNav extends FlexBoxView {
  public readonly tabs: TeamTab[] = [];

  public setup(opts: TeamNavConfig) {
    this.removeAllSubviews();

    let totalWidth = 0;
    let totalHeight = 0;
    for (let index = 0; index < opts.tabs.length; index++) {
      const data = opts.tabs[index];
      const tab = new TeamTab({
        superview: this,
        tracking: data.tracking,
        width: 238,
        height: 86,
        onClick: async () => {
          sounds.sfx.play('ok');
          this.updateSelected(index);
          return data.onClick();
        },
        ...(opts.tabOpts ?? {}),
      });

      totalWidth += tab.style.width;
      totalHeight = Math.max(tab.style.height, totalHeight);
      this.tabs.push(tab);
      tab.label = data.label;
      tab.tracking = data.tracking;
    }

    this.updateOpts({
      width: totalWidth,
      height: totalHeight,
    });

    // Select active tab.
    const selected = opts.selectedIndex ?? 0;
    this.updateSelected(selected);
    void opts.tabs[selected].onClick();
  }

  public updateSelected(index: number) {
    if (index < 0 || index >= this.tabs.length) {
      throw new Error(`Team Nav: Invalid tab index selected ${index}`);
    }

    this.tabs.forEach((tab, i) => {
      tab.active = i === index;
      tab.updateOpts({ blockEvents: tab.active });
    });
  }
}
